/**
 * Находит знаки пунктуации, после которых сразу идет непробельный символ.
 * Запятая между цифрами (десятичный разделитель) исключается.
 * Примеры:
 * - `Привет,мир!Как дела?` -> `Привет, мир! Как дела?`
 * - `Объем 23,5 м3` -> `Объем 23,5 м3`
 */
export const REGEX_PUNCTUATION_WITHOUT_SPACE = /([.;:!?]|,(?=\D))(?=\S)/g;
